import services from '../services'
import * as types from './mutation-types'

export const getAll = ({ commit }, params) => (
  services.list(params).then(res => {
    commit(types.SET_FLIGHT_BLOCKS, res.data)
  })
)

export const show = async ({ commit }, id) => {
  await services.show(id).then(res => {
    commit(types.SET_FLIGHT_BLOCK, res.data.data)
  })
}

export const save = async ({ commit }, obj) => {
  const res = await services.save(obj)
  commit(types.SET_FLIGHT_BLOCK, res.data.data)
  return res
}

export const update = async ({ commit }, obj) => {
  const res = await services.update(obj)
  commit(types.SET_FLIGHT_BLOCK, res.data.data)
  return res
}

export const toggle = async ({ commit }, id) => {
  const res = await services.toggle(id)
  commit(types.SET_FLIGHT_BLOCK, res.data.data)
  return res
}

export const duplicate = async ({ commit }, id) => {
  const res = await services.duplicate(id)
  return res
}

export const remove = async ({ commit }, id) => {
  const res = await services.remove(id)
  return res
}
